import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getDisplayOptionsFromRedux } from 'AppSrc/core/components/forms/form-base-components/redux/display-options/get-display-options-from-redux';
import PropTypes from 'prop-types';
import {
  vFParamsPropShape,
  disabledFieldOptionsShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import {
  VFMultiSelectBase,
} from './v-f-multi-select-base';
import 'AppSrc/core/style/components/form/form-base-components/v-f-multi-select.css';


const getTextForValuesMultiSelect = (params) => {
  const {
    displayOptions,
    value,
    placeholder,
    vFParams,
  } = params;

  const {
    getDisplayValue,
  } = vFParams;

  const noValue = placeholder ? [placeholder] : ['-'];
  if (value === null || value === undefined) {
    return noValue;
  }

  if (getDisplayValue) {
    return getDisplayValue({
      value,
      noValue,
    });
  }

  const displayValuesSelected = [];

  // for each selectedOption, extracts out the text for that specefic option
  value.forEach((selectedValue) => {
    const selectedDisplayOption = displayOptions.find((displayOption) => displayOption.value === selectedValue);

    // if the array is empty but we can't find the text, something has gone wrong
    const hasText = selectedDisplayOption && selectedDisplayOption.text;

    // If we can't find the text for value, then it's most likely a value we get from the server. In which
    // case we display the raw value (as in these cases it should ALWAYS be the text the user sees)
    if (!hasText) {
      displayValuesSelected.push(selectedValue);
      return null;
    }

    displayValuesSelected.push(selectedDisplayOption.text);
    return null;
  });

  return displayValuesSelected.length > 0 ? displayValuesSelected : noValue;
};





class VFMultiSelectComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
  }

  componentDidMount() {
    this.ifDisabledSetDefaultValues({});
    const {
      vFParams,
    } = this.props;
    const {
      getDisplayOptionsOnMount,
    } = vFParams;


    if (getDisplayOptionsOnMount) {
      this.props.dispatchGetDisplayOptionsOnMount();
    }
  }

  componentDidUpdate(prevProps) {
    this.ifDisabledSetDefaultValues({
      prevProps,
    });
  }



  updateValue(valueToSet) {
    const {
      field,
      displayOptions,
      vFParams,
    } = this.props;


    const {
      parseSelectedValue,
    } = vFParams;

    const {
      name,
      value,
    } = field;

    const correctedValue = parseSelectedValue ? parseSelectedValue({
      displayOptions,
      valueToSet,
      // parse selected value also needs access to the original field value
      // so that it can maintain things metadata such as ther readonly flag
      // for approver options
      currentFieldValue: value,
    }) : valueToSet;

    this.props.form.setFieldValue(name, correctedValue);
    this.props.form.setFieldTouched(name, true);

  }

  ifDisabledSetDefaultValues(params) {
    const {
      prevProps,
    } = params;
    const {
      name,
      value,
    } = this.props.field;
    const {
      disabled,
      disabledValue,
      unDisabledValue,
    } = this.props.disabledFieldOptions;
    // check if the previous props had set it to disabled
    const prevDisabled = prevProps ? prevProps.disabledFieldOptions.disabled : false;

    if (!disabled) {
      if (prevDisabled) {
        this.props.form.setFieldValue(name, unDisabledValue);
        this.props.form.setFieldTouched(name, true);
      }
      return null;
    }

    if (JSON.stringify(value) !== JSON.stringify(disabledValue)) {

      this.props.form.setFieldValue(name, disabledValue);
      this.props.form.setFieldTouched(name, true);
    }
    return null;
  }

  render() {

    const {
      vFParams,
      field,
      form,
      displayOptions,
      readOnly,
      disabledFieldOptions,
      optional,
    } = this.props;

    const {
      name,
      value,
    } = field;

    const {
      formatDisplayOptions,
      formatCurrentValue,
      placeholder,
    } = vFParams;

    const formErrors = form.errors;
    const touched = form.touched[name];


    const errors = formErrors[name];

    // we don't pass in simplifiedData into getTextForValuesMultiSelect because getTextForValuesMultiSelect
    // can be called from the data layer, which doesn't use simplified data
    const displayTexts = getTextForValuesMultiSelect({
      displayOptions,
      value,
      placeholder,
      vFParams,
    });

    const displayText = displayTexts.join(', ');



    const formattedDisplayOptions = formatDisplayOptions ? formatDisplayOptions({ displayOptions, value }) : displayOptions;
    const simplifiedValue = formatCurrentValue ? formatCurrentValue({ value }) : value;



    return (

      <VFMultiSelectBase
        displayOptions={formattedDisplayOptions}
        readOnly={readOnly}
        disabledFieldOptions={disabledFieldOptions}
        optional={optional}
        vFParams={vFParams}
        name={name}
        value={simplifiedValue}
        errors={errors}
        touched={touched}
        setValue={this.updateValue}
        displayText={displayText}
      />
    );
  }
}



VFMultiSelectComponent.propTypes = {
  vFParams: vFParamsPropShape,
  // we have to define the value within the data structure for field
  field: getFieldPropShape(PropTypes.array),
  form: formPropShape,
  // The value of display options can take on a variety of shapes here
  displayOptions: PropTypes.arrayOf(PropTypes.shape(({
    text: PropTypes.string,
    value: PropTypes.any,
  }))),
  disabledFieldOptions: disabledFieldOptionsShape,
  readOnly: PropTypes.bool,
  optional: PropTypes.bool,
  getDisplayOptionsOnMount: PropTypes.func,
  dispatchGetDisplayOptionsOnMount: PropTypes.func,
};





const mapStateToProps = (state, ownProps) => {

  const {
    displayOptions,
    field,
  } = ownProps;

  const {
    name, // refered to as fieldId outside of formik
  } = field;


  const displayOptionsFromRedux = getDisplayOptionsFromRedux({
    state,
    fieldId: name,
  });

  if (displayOptionsFromRedux.length > 0) {
    return ({
      displayOptions: [
        ...displayOptionsFromRedux,
        ...displayOptions,
      ],
    });
  }

  // dropdown base loads with it's ownProps
  return ({});


};

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchGetDisplayOptionsOnMount: () => {
    dispatch(ownProps.vFParams.getDisplayOptionsOnMount());
  },
  dispatchGetDisplayOptionsOnUpdate: (value) => {
    dispatch(ownProps.vFParams.getDisplayOptionsOnUpdate(value));
  },
});

const ComponentToRenderWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VFMultiSelectComponent);


// Most of the time it's inefficent and uneeded to connect drop downs to redux. But when we do
// need them to be, we can just pass in withRedux and then this connects them :)
const VFMultiSelect = (props) => {

  const {
    vFParams,
  } = props;

  const withRedux = vFParams ? vFParams.withRedux : false;

  if (withRedux) {
    // This is a curried component. So we need all props to bleed through. The layer above and below tracks what the props are
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    return <ComponentToRenderWithRedux {...props} />;
  }

  // This is a curried component. So we need all props to bleed through. The layer above and below tracks what the props are
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  return <VFMultiSelectComponent {...props} />;
};

VFMultiSelect.propTypes = {
  withRedux: PropTypes.bool,
  vFParams: vFParamsPropShape,
};




const noValueVFMultiSelect = (value) => {
  if (value === null) {
    return true;
  }

  if (value.length === 0) {
    return true;
  }

  return false;
};


// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_MULTI_SELECT = 'v-f-multi-select';

export {
  VF_MULTI_SELECT,
  VFMultiSelect,
  noValueVFMultiSelect,
  getTextForValuesMultiSelect,
};
